// extracted by mini-css-extract-plugin
export var panel = "styles-module--panel--50c82";
export var scroll = "styles-module--scroll--0c115";